import { rem } from '@mantine/core';

export const FORM_TYPE = {
	LABEL_TEXT: 'Label Text',
	SINGLE_LINE_TEXT: 'Single Line Text',
	NUMBER: 'Number',
	PARAGRAPH_TEXT: 'Paragraph Text',
	CHECKBOX: 'Checkbox',
	DROPDOWN: 'Dropdown',
	CALENDAR: 'Calendar',
	MULTISELECT_DROPDOWN: 'Multi Select Dropdown',
	EMPLOYEE_SELECT: 'Employee Select',
	EMPLOYEE_SELECT_FREE_SOLO: 'Employee Select Free Solo',
};

export const CASE_FORM_TYPE = {
	SHORT_TEXT: 'SHORT_TEXT',
	LONG_TEXT: 'LONG_TEXT',
	NUMBER: 'NUMBER',
	DATE: 'DATE',
	DATETIME: 'DATETIME',
	RICH_TEXT: 'RICH_TEXT',
	CHECKBOX: 'CHECKBOX',
	BOOLEAN: 'BOOLEAN',
	EMAIL: 'EMAIL',
	PHONE: 'PHONE',
	URL: 'URL',
	ATTACHMENT: 'ATTACHMENT',
	TOGGLE: 'TOGGLE',
	SELECT: 'SELECT',
	MULTI_SELECT: 'MULTI_SELECT',
	RADIO: 'RADIO',
};

export const DEFAULT_FORM_TYPE = {
	...FORM_TYPE,
	MULTI_INPUT_EMAILS_FIELD: 'Multiple Input Field (Email)',
	MULTI_INPUT_FREE_HAND_FIELD: 'Multiple Input Field (Free Hand)',
};

export const DROPDOWN_TYPES = [
	'Dropdown',
	'Dependent Field',
	'Company List',
	'Groups',
	'Type',
	'Priority',
	'Product',
	'Source',
	'Tag',
	'Multi Select Dropdown',
];

export const STATUS_TYPES = {
	IDLE: 'IDLE',
	LOADING: 'LOADING',
	SUCCESS: 'SUCCESS',
	ERROR: 'ERROR',
	UPDATING: 'UPDATING',
};

export const SURVEY_FIELD_TYPES = {
	RATING: 0,
	TEXT: 1,
	DESCRIPTION: 2,
};

export const MessageSender = {
	CONTACT: 'Contact',
	AGENT: 'Agent',
};

export const mantineThemOptions = {
  /** Put your mantine theme override here */
  fontFamily: "Open Sans, sans-serif",
  primaryColor: "blue",

  shadows: {
    md: "1px 1px 3px rgba(0, 0, 0, .25)",
    xl: "5px 5px 3px rgba(0, 0, 0, .25)",
  },

  headings: {
    fontFamily: "Roboto, sans-serif",
    sizes: {
      h1: { fontSize: rem(36) },
    },
  },
};